module.exports = __webpack_public_path__ + "img/thunderforest-cycle.6f00a17b.jpg";